const PostDurationSchedulesErrorCode = {
  INTERVAL_HAS_DUTY_COURSE: '10001',
} as const;
export const PostDurationSchedulesErrorMessage: Record<string, string> = {
  [PostDurationSchedulesErrorCode.INTERVAL_HAS_DUTY_COURSE]:
    '此時段已有安排課程',
};
